import { Chip, Panel } from '@elotech/components';
import {
  DynamicFormDataView,
  DynamicFormRender
} from '@elotech/react-components';
import React from 'react';

import {
  DynamicField,
  FormularioDinamicoRuntime
} from '../../type/FormularioDinamico';
import PerguntasCustomizadas from './PerguntasCustomizadas';
import { Situacao } from './situacao';
import { ArquivoHandlers } from './useArquivoHandlers';

interface Props {
  formulario: FormularioDinamicoRuntime;
  situacao: Situacao;
  values?: Record<string, unknown>;
  valuesAplicados?: Record<string, unknown>;
  somenteLeitura?: boolean;
  tokenPromise?: () => Promise<string>;
  arquivo?: ArquivoHandlers;
  perguntasCustomizadas: DynamicField[];
  editandoPerguntas: boolean;
  salvandoPerguntas: boolean;
  temRascunhoPerguntas: boolean;
  permiteEditarPerguntas: boolean;
  onValueChanges: (values: Record<string, unknown>) => void;
  onStatusChanges: (valida: boolean) => void;
  onAlternarEdicaoPerguntas: () => void;
  onRascunhoPerguntasChange: (fields: DynamicField[]) => void;
  onConfirmarPerguntas: () => void;
}

const FormularioDinamicoCard: React.FC<Props> = ({
  formulario,
  situacao,
  values,
  valuesAplicados,
  somenteLeitura,
  tokenPromise,
  arquivo,
  perguntasCustomizadas,
  editandoPerguntas,
  salvandoPerguntas,
  temRascunhoPerguntas,
  permiteEditarPerguntas,
  onValueChanges,
  onStatusChanges,
  onAlternarEdicaoPerguntas,
  onRascunhoPerguntasChange,
  onConfirmarPerguntas
}) => (
  <Panel
    isTable={false}
    expansible
    title={
      <>
        {formulario.icone && (
          <i aria-hidden="true" className={`${formulario.icone} mr-xs`} />
        )}
        {formulario.titulo}
        <Chip
          className="pull-right"
          color={situacao.cor}
          value={situacao.rotulo}
        />
      </>
    }
  >
    {somenteLeitura ? (
      <DynamicFormDataView
        values={values}
        emptyMessage="Formulário ainda não respondido."
        fileDownloader={arquivo?.downloader}
      />
    ) : (
      <>
        <DynamicFormRender
          fields={formulario.fields}
          values={valuesAplicados}
          tokenPromise={tokenPromise}
          fileProcessor={arquivo?.processor}
          fileDownloader={arquivo?.downloader}
          valueChanges={onValueChanges}
          statusChanges={onStatusChanges}
        />

        {formulario.aceitaPerguntasCustomizadas && permiteEditarPerguntas && (
          <PerguntasCustomizadas
            instanciaId={formulario.id}
            perguntas={perguntasCustomizadas}
            editando={editandoPerguntas}
            salvando={salvandoPerguntas}
            temRascunho={temRascunhoPerguntas}
            tokenPromise={tokenPromise}
            arquivo={arquivo}
            onAlternarEdicao={onAlternarEdicaoPerguntas}
            onRascunhoChange={onRascunhoPerguntasChange}
            onConfirmar={onConfirmarPerguntas}
          />
        )}
      </>
    )}
  </Panel>
);

export default FormularioDinamicoCard;
